import React, { useState, useEffect, useMemo } from "react";
//utils
import {
  ordersCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import { useHistory } from "react-router-dom";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import currency from "../../../utils/currency";
import { date } from "../../../utils/dateTime";
//componrnt
import TabPanel from "../../../components/TabPanel";
import useStyle from "./style";
import Gap from "../../../components/Gap";
import { useSnackbar } from "notistack";
//material
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ButtonGroup from "@material-ui/core/ButtonGroup";
// import Circle from "../../../components/appLoading/circle";
import EmptyOrder from "./EmptyOrder";
import DialogTracking from "./DialogTracking";
import CopyToClipboard from "react-copy-to-clipboard";
import { Grid } from "@material-ui/core";

const SubOrderItem = ({ suborder }) => {
  const classes = useStyle();
  const history = useHistory();
  const [seeProduk, setSeeProduk] = useState(0);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const handleCloseDel = () => {
    setAlert(false);
  };

  const alamat = useMemo(() => {
    let penerima = "";
    let line1 = "";
    let line2 = [];
    let line3 = [];

    const {
      alamat_tujuan: {
        nama_penerima,
        no_telepon,
        alamat_lengkap,
        kelurahan,
        kecamatan,
        kota,
        provinsi,
      },
    } = suborder;
    penerima += `${nama_penerima} (${no_telepon})`;
    line1 += alamat_lengkap ? alamat_lengkap : "";
    line2.push(kelurahan?.name);
    line2.push(kecamatan?.name);
    line3.push(kota?.name);
    line3.push(provinsi?.name);
    line3.push(kelurahan?.postcode);

    line2 = line2.join(", ");
    line3 = line3.join(", ");

    return (
      <div>
        <Typography className={classes.liquidBold}>{penerima}</Typography>
        <Typography className={classes.liquidBold}>{line1}</Typography>
        <Typography className={classes.liquidBold}>{line2}</Typography>
        <Typography className={classes.liquidBold}>{line3}</Typography>
      </div>
    );
  }, [suborder]);
  const products = useMemo(() => {
    const {
      products_name,
      products_variant1,
      products_variant2,
      products_qty,
    } = suborder;
    return (
      <Typography
        className={classes.liquidBold}
      >{`${products_name?.[0]} - ${products_variant1?.[0]} ${products_variant2?.[0]} - ${products_qty?.[0]} pcs `}</Typography>
    );
  }, [suborder]);

  const handleResi = (item) => () => {
    // console.log("hasil", item?.replace(/-|[+]/gm, "") ?? "");
    window.open(item);
  };
  const [dialogTrac, setDialogTrac] = useState({
    open: false,
    subOrder: {},
  });

  const handleTrac = (item) => (e) => {
    setDialogTrac({
      open: true,
      subOrder: item,
    });
  };

  const receiveOrder = async () => {
    if (loading) {
      return null;
    }
    setLoading(true);

    try {
      const callreceiveOrder = firefunctions.httpsCallable("receiveOrder");

      await callreceiveOrder({
        suborder_id: suborder.id,
        order_id: suborder.order_id,
      });
    } catch (error) {
      enqueueSnackbar("Mohon maaf gagal mengubah status pesanan!", {
        variant: "error",
      });
      console.log(error.message);
    }
    setLoading(false);
  };

  const sumQty =
    suborder?.products_qty?.reduce?.((total, val) => {
      if (!val) return total;
      return total + val;
    }, 0) ?? 0;

  return (
    <>
      <Paper elevation={0} className={classes.wrapPaper}>
        {/* <div className={classes.wrapHeaderTitle}>
          <div>
            <Typography className={classes.liquidBold}>
              #{suborder.kode_order}
            </Typography>
            <Typography className={classes.liquidBold}>
              #{suborder.kode_suborder}
            </Typography>
            <Typography className={classes.liquidSecondList}>
              {date(suborder.created_at?.toDate?.())}
            </Typography>
          </div>
          <div className={classes.belumBayar}>
            <Brightness1Icon style={{ fontSize: "10px" }} color="primary" />
            <Typography className={classes.liquidSecondList}>
              Dikirim
            </Typography>
          </div>
        </div> */}
        <div className={classes.wrapHeaderTitle}>
          <div>
            <Typography className={classes.liquidSecondList}>
              {date(suborder.created_at?.toDate?.())}
            </Typography>
          </div>
          <div className={classes.belumBayar}>
            <Brightness1Icon
              color="primary"
              style={{ fontSize: "10px", marginRight: "5" }}
            />
            <Typography className={classes.liquidSecondList}>
              Dikirim
            </Typography>
          </div>
        </div>
        <Divider />
        <div
          className={classes.wrapHeaderTitle}
          style={{ marginBottom: "10px", marginTop: "10px" }}
        >
          <div>
            <CopyToClipboard
              text={suborder.kode_order}
              onCopy={() => {
                enqueueSnackbar("Kode Order Berhasil Disalin", {
                  variant: "success",
                });
              }}
            >
              <Typography variant="caption" display="block">
                <b>{suborder.kode_order}</b>
              </Typography>
            </CopyToClipboard>{" "}
            <Typography variant="caption" display="block">
              <b>{suborder.kode_suborder}</b>
            </Typography>
          </div>
          <div className={classes.belumBayar}>
            <FileCopyOutlinedIcon
              color="primary"
              style={{ width: "15", height: "15" }}
            />
          </div>
        </div>
        {/* <Grid container direction="row" justify="center" alignItems="center">
          <div className={classes.orderColTopLeft}>
            <div className={classes.innerRow}>
              <div className={classes.timelineStatus}>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      suborder.status === "pending" ||
                      suborder.status === "paid" ||
                      suborder.status === "on-process" ||
                      suborder.status === "on-delivery" ||
                      suborder.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <ScheduleIcon />
                  </div>
                </div>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      suborder.status === "paid" ||
                      suborder.status === "on-process" ||
                      suborder.status === "on-delivery" ||
                      suborder.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <CheckCircleIcon />
                  </div>
                </div>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      suborder.status === "on-process" ||
                      suborder.status === "on-delivery" ||
                      suborder.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <AutorenewIcon />
                  </div>
                </div>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      suborder.status === "on-delivery" ||
                      suborder.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <LocalShippingIcon />
                  </div>
                </div>
                <div className={classes.timelineBox}>
                  <div
                    className={`${
                      suborder.status === "received"
                        ? `${classes.checkpoint} ${classes.active}`
                        : classes.checkpoint
                    }`}
                  >
                    <RoomIcon />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid> */}
        <List>
          {/* <ListItem>
            <ListItemText
              primary={
                <Typography className={classes.liquidPrimary}>
                  {sumQty} pcs / {suborder?.products?.length} produk
                </Typography>
              }
            />
            <ListItemSecondaryAction>
              <Typography className={classes.liquidBold}>
                Total Pembayaran{" "}
              </Typography>
              <Typography className={classes.liquidPrimary}>
                {currency(suborder.total_pembayaran)}
              </Typography>
            </ListItemSecondaryAction>
          </ListItem> */}
          {suborder?.resi_otomatis_mp ? (
            <ListItem
              style={{ backgroundColor: "#C9D6FC" }}
              className={classes.accordion}
            >
              <Grid container>
                <Grid item xs>
                  <Typography variant="caption" display="block">
                    Kode Resi Marketplace :
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="caption" display="block">
                    {suborder?.resi_otomatis_mp_resi}
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
          ) : null}
          <ListItem style={{ backgroundColor: "#C7D9FF" }}>
            <ListItemText
              primary={
                <Typography className={classes.liquidPrimary}>
                  Dikirim ke
                </Typography>
              }
              secondary={alamat}
            />
          </ListItem>
          {seeProduk !== 0 ? (
            <>
              {suborder.products?.map?.((product, index) => {
                return (
                  <ListItem button onClick={() => setSeeProduk(0)}>
                    <ListItemAvatar>
                      <Avatar
                        variant="square"
                        src={
                          suborder.products?.[index]?.variant?.thumbnail?.[0]
                        }
                      />
                    </ListItemAvatar>
                    <ListItemText
                      secondary={
                        <div>
                          {/* <Typography className={classes.liquidPrimary}>
                            Produk
                          </Typography> */}
                          <Typography className={classes.liquidBold}>
                            {product.nama} - Ukuran{" "}
                            {product.variant?.variant1.nilai} Warna{" "}
                            {product.variant?.variant2.nilai} -{" "}
                            {suborder?.products_qty?.[index]} pcs
                          </Typography>
                          <Typography className={classes.liquidPrimary}>
                            Harga Barang
                          </Typography>
                          <Typography className={classes.liquidBold}>
                            {currency(
                              (suborder.products_subtotal?.[index] ?? 0) /
                                (suborder.products_qty?.[index] ?? 1)
                            )}
                          </Typography>
                        </div>
                      }
                    />
                  </ListItem>
                );
              })}
            </>
          ) : (
            <>
              {suborder.products?.length > 1 ? (
                <>
                  <ListItem button onClick={() => setSeeProduk(1)}>
                    <ListItemAvatar>
                      <Avatar
                        variant="square"
                        src={suborder.products?.[0]?.variant?.thumbnail?.[0]}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      secondary={
                        <div>
                          {/* <Typography className={classes.liquidPrimary}>
                            Produk
                          </Typography> */}
                          <Typography className={classes.liquidBold}>
                            {products}
                            More...
                          </Typography>
                          <Typography className={classes.liquidPrimary}>
                            Total Pembayaran
                          </Typography>
                          <Typography className={classes.liquidBold}>
                            {currency(suborder.total_pembayaran)}
                          </Typography>
                        </div>
                      }
                    />
                  </ListItem>
                </>
              ) : (
                <>
                  {suborder.products?.map?.((product, index) => {
                    return (
                      <ListItem>
                        <ListItemAvatar>
                          <Avatar
                            variant="square"
                            src={
                              suborder.products?.[0]?.variant?.thumbnail?.[0]
                            }
                          />
                        </ListItemAvatar>
                        <ListItemText
                          secondary={
                            <div>
                              {/* <Typography className={classes.liquidPrimary}>
                                Produk
                              </Typography> */}
                              <Typography className={classes.liquidBold}>
                                {products}
                              </Typography>
                              <Typography className={classes.liquidPrimary}>
                                Total Pembayaran
                              </Typography>
                              <Typography className={classes.liquidBold}>
                                {currency(suborder.total_pembayaran)}
                              </Typography>
                            </div>
                          }
                        />
                      </ListItem>
                    );
                  })}
                </>
              )}
            </>
          )}
          {!suborder?.resi_otomatis_mp ? (
            <ListItem style={{ justifyContent: "center" }}>
              <Button
                fullWidth
                variant="outlined"
                size="small"
                color="primary"
                onClick={handleResi(suborder?.shipper_info?.resi_url)}
              >
                <PlaylistAddCheckIcon
                  style={{ marginRight: "10px", width: "20px" }}
                />
                Resi
              </Button>
              <Gap width={30} />
              <Button
                fullWidth
                variant="outlined"
                size="small"
                color="primary"
                onClick={handleTrac(suborder)}
              >
                <LocalShippingIcon
                  style={{ marginRight: "10px", width: "20px" }}
                />
                Tracking
              </Button>
            </ListItem>
          ) : (
            <>
              <ListItem style={{ justifyContent: "center" }}>
                <Button
                  fullWidth
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={() => setAlert(true)}
                >
                  Diterima
                </Button>
              </ListItem>
              <Dialog
                open={alert}
                keepMounted
                onClose={handleCloseDel}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogContent>
                  <DialogTitle id="alert-dialog-slide-title">
                    <Typography>
                      Apakah anda yakin ingin mengubah status pesanan ini
                      menjadi diterima?
                    </Typography>
                  </DialogTitle>
                </DialogContent>
                <DialogActions>
                  <ButtonGroup fullWidth variant="text">
                    <Button color="primary" onClick={receiveOrder}>
                      Yes
                    </Button>
                    <Button color="secondary">No</Button>
                  </ButtonGroup>
                </DialogActions>
              </Dialog>
            </>
          )}

          <Divider />
          <ListItem>
            <ListItemIcon style={{ minWidth: "40px" }}>
              <LocalShippingIcon />
            </ListItemIcon>
            <ListItemText
              secondary={
                <Typography className={classes.liquidSecondList}>
                  Paket sedang dalam proses pengiriman
                </Typography>
              }
            />
            <ListItemSecondaryAction>
              <Button
                onClick={() => history.push("/")}
                color="primary"
                variant="contained"
                size="small"
              >
                <Typography
                  style={{ color: "white", fontSize: "10px", padding: "2px" }}
                  className={classes.liquidSecondList}
                >
                  Beli Lagi
                </Typography>
              </Button>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </Paper>
      <Gap height={30} />
      <DialogTracking
        open={dialogTrac.open}
        subOrder={dialogTrac.subOrder}
        handleClose={() => {
          setDialogTrac({
            open: false,
            subOrder: {},
          });
        }}
      />{" "}
    </>
  );
};

async function fetchSuborders(order) {
  const suborders = [];
  try {
    const subordersRef = await ordersCollection
      .doc(order.id)
      .collection("suborders")
      .where("order_info.owner_id", "==", order.order_info.owner_id)
      .where("status_pengiriman", "in", ["on-delivery"])
      .get();

    subordersRef.docs.map((r) => {
      suborders.push({
        kode_order: order.kode_order,
        order_id: order.id,
        id: r.id,
        ...r.data(),
      });
    });
  } catch (e) {
    console.log(e.message);
  }

  return suborders;
}

function DiKirim({ value, modes }) {
  const { orders } = useData();
  const [suborders, setSuborders] = useState([]);
  const [isReady, setIsReady] = useState(false);

  const pendingOrders =
    orders
      ?.filter((order) => {
        return (
          modes === order.order_info?.location &&
          (order.status === "on-delivery" || order.status === "received")
        );
      })
      .sort((a, b) => {
        const m2 = b.created_at?.toMillis?.() ?? 0;
        const m1 = a.created_at?.toMillis?.() ?? 0;

        return m2 - m1;
      }) ?? [];

  async function getSuborders() {
    const nextSuborders = [];

    for await (const order of pendingOrders) {
      const res = await fetchSuborders(order);
      nextSuborders.push(...res);
    }

    setSuborders(nextSuborders);
    setIsReady(true);
  }

  useEffect(() => {
    getSuborders();
  }, []);

  // if (!isReady) {
  //   return <Circle />;
  // }
  return (
    <TabPanel style={{ backgroundColor: "#EFF1FE" }} value={value} index="sent">
      <div>
        {suborders && suborders.length > 0 ? (
          suborders.map((item) => {
            return <SubOrderItem key={item?.id} suborder={item} />;
          })
        ) : (
          <EmptyOrder />
        )}
      </div>
    </TabPanel>
  );
}

export default DiKirim;
